import React, { ReactNode } from "react";

import Heading from "../../../heading";

type Props = {
  className?: string;
  title: ReactNode;
  description: ReactNode;
  figure: ReactNode;
};

const Card = ({ className, title, description, figure }: Props) => (
  <div className={className}>
    <div className="h-full text-center border-2 border-primary bg-transparent rounded-md shadow-lg py-8 p-5 md:p-10">
      <figure className="h-14 w-14 md:h-28 md:w-28 relative mx-auto">{figure}</figure>
      <Heading tag="h4" className="text-white mt-4 md:mt-10">
        {title}
      </Heading>
      <p className="mt-2 md:mt-4 text-gray-100">{description}</p>
    </div>
  </div>
);

export default Card;
